import React__default from 'react';

function sameType(node, type) {
    return React__default.isValidElement(node) && (node.type === type);
}

export { sameType };
